export const DEFAULT_PREFERENCE = { enableGoals: true, enableProjects: true }
